import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const HasFinishedSignupReducer = (state = null, { type, payload }) => {
    switch (type) {
        case MultichainActionType.SET_HAS_FINISHED_SIGNUP:
            return payload;
        default:
            return state;
    }
};
